import { render, staticRenderFns } from "./LicenceVue.vue?vue&type=template&id=db16a598&scoped=true&"
import script from "./LicenceVue.vue?vue&type=script&lang=js&"
export * from "./LicenceVue.vue?vue&type=script&lang=js&"
import style0 from "./LicenceVue.vue?vue&type=style&index=0&id=db16a598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db16a598",
  null
  
)

export default component.exports